import { formatCapexDataList } from './capex.utils'
import { CapexDataApiResponse } from './capex.types'
import { solarProductAxios } from '@infrastructure/apiService'
import { ICapexRepository } from '@modules/capex/domain'
import { CapexData } from '@modules/capex/domain/capex.types'

export const capexService: ICapexRepository = {
  getCapexData: async (): Promise<CapexData[]> => {
    const { data } =
      await solarProductAxios.get<CapexDataApiResponse[]>(`/private/capex`)
    return formatCapexDataList(data)
  },
  uploadCapexFile: async (file: File): Promise<void> => {
    const formData = new FormData()
    formData.append('file', file)

    await solarProductAxios.post(`/private/capex`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  exportCapexFile: async (configId: string): Promise<Blob> => {
    const { data } = await solarProductAxios.get<Blob>(
      `/private/capex/${configId}/export`,
      {
        responseType: 'blob',
      }
    )
    return data
  },
}
